import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';
/**
 * 其他-模块
 */

var other = {
  path: '/without',
  redirect: '/without/ecology',
  component: RootLayout,
  children: [{
    path: 'ecology',
    name: 'Ecology',
    component: function component() {
      return import('@/views/other/ecology');
    },
    meta: {
      title: '' // 生态馆

    }
  }, {
    path: 'brand',
    name: 'Brand',
    component: function component() {
      return import('@/views/other/brand');
    },
    meta: {
      title: '',
      // 品牌馆
      keepAlive: true
    }
  }, {
    path: 'theme',
    name: 'Theme',
    component: function component() {
      return import('@/views/other/theme');
    },
    meta: {
      title: '上新',
      // 上新
      keepAlive: true
    }
  }]
};
export default other;